// src/components/api.ts

import { EVENTS } from '../constants/defaults'
import { revokeConsent as revoke, exportConsent as exportData } from '../core/consent-manager'

/**
 * Show cookie settings modal
 * Usage: import { showCookieSettings } from '@meui-creative/cookies'
 */
export function showCookieSettings(): void {
  if (typeof window === 'undefined') return

  const event = new CustomEvent(EVENTS.SETTINGS_OPENED)
  window.dispatchEvent(event)
}

/**
 * Revoke user consent
 * Usage: import { revokeConsent } from '@meui-creative/cookies'
 */
export function revokeConsent(): void {
  revoke()
}

/**
 * Export user consent data (for GDPR requests)
 * Usage: import { exportConsent } from '@meui-creative/cookies'
 */
export function exportConsent() {
  return exportData()
}
